import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AssesmentComponent } from '@app-modules/feature/products/assesment/assesment.component';
import { BackgroundHomepageComponent } from './components/background-homepage/background-homepage.component';
import { CompleteProfileComponent } from './components/complete-profile/complete-profile.component';
import { AuthGuard } from './components/guards/auth.guard';
import { HomeComponent } from './components/home/home.component';
import { NeetComponent } from '@app-modules/feature/products/neet/neet.component';
import { JeeComponent } from '@app-modules/feature/products/jee/jee.component';
import { SpecialSeriesComponent } from '@app-modules/feature/products/special-series/special-series.component';
import { AboutComponent } from '@app-modules/feature/products/about/about.component';
import { DefaultLayoutComponent } from './components/layout/default-layout/default-layout.component';
import { LiveClassLayoutComponent } from './components/layout/live-class-layout/live-class-layout.component';
import { ClassLayoutComponent } from './components/layout/class-layout/class-layout.component';
import { ProfileGuard } from './components/guards/profile.guard';
import { ComingsoonComponent } from '@app-shared/components/comingsoon/comingsoon.component';
import { NeetLandingComponent } from '@app-modules/feature/products/neet-landing/neet-landing.component';
import { TestSeriesComponent } from '@app-modules/feature/products/test-series/test-series.component';
import { environment } from 'src/environments/environment';
import { SubscriptionGuard } from './components/guards/subscription.guard';
import { ThankYouComponent } from '@app-modules/feature/products/thankyou/thankyou.component';
import { JeeLiveclassComponent } from '@app-modules/feature/products/jee-liveclass/jee-liveclass.component';
import { IliteComponent } from '@app-modules/feature/products/ilite/ilite.component';
import { PaynowregistrationComponent } from '@app-modules/feature/products/paynowregistration/paynowregistration.component';

import { TeacherHomeComponent } from './components/teacher-home/teacher-home.component';
import { CongrajulationsComponent } from '@app-modules/feature/products/congrajulations/congrajulations.component';
import { RepeaterComponent } from '@app-modules/feature/products/repeater/repeater.component';
import { SignInComponent } from '@app-shared/components/auth/sign-in/sign-in.component';
import { VerifyOtpComponent } from '@app-shared/components/auth/verify-otp/verify-otp.component';
import { PasswordLoginComponent } from '@app-shared/components/auth/password-login/password-login.component';
import { CreatePasswordComponent } from '@app-shared/components/auth/create-password/create-password.component';
import { TargetExamComponent } from '@app-shared/components/auth/target-exam/target-exam.component';
import {EnrollnowComponent} from '@app-shared/components/enrollnow/enrollnow.component';
import { InviteAndEarnComponent } from '@app-modules/feature/my-referral/invite-and-earn/invite-and-earn.component';
import { MyReferralsComponent } from '@app-modules/feature/my-referral/my-referrals/my-referrals.component';
import {FestivalOfferComponent} from '@app-shared/components/festival-offer/festival-offer.component';
import {ScoreActionsComponent} from '@app-shared/components/score-actions/score-actions.component';
import { DiagnosticTestComponent } from '@app-shared/components/diagnostic-test/diagnostic-test.component';
import { DiagnosticThankyouComponent } from '@app-shared/components/diagnostic-thankyou/diagnostic-thankyou.component';
import {ScoreNewPaymentComponent} from '@app-shared/components/score-new-payment/score-new-payment.component';
import {ScoreNewThankyouComponent} from '@app-shared/components/score-new-thankyou/score-new-thankyou.component';
import { ScoreTestReportComponent } from '@app-shared/components/score-test-report/score-test-report.component';
import { CuetPaymentComponent } from '@app-shared/components/cuet-payment/cuet-payment.component';
// import { SelfLearnSubjectComponent } from '@app-selflearnv2module/feature/self-learn-v2/components/self-learn-subject/self-learn-subject.component'; 
// import { SelfLearnVideoPlaybackComponent } from '@app-selflearnv2module/feature/self-learn-v2/components/self-learn-video-playback/self-learn-video-playback.component';
import { OnboardingComponent } from '@app-shared/components/auth/onboarding/onboarding.component';
import { SelfLearnSubjectComponent } from '@app-selflearnv2module/feature/self-learn-v2/components/self-learn-subject/self-learn-subject.component';
import { SelfLearnVideoPlaybackComponent } from '@app-selflearnv2module/feature/self-learn-v2/components/self-learn-video-playback/self-learn-video-playback.component';
import { YtVideosComponent } from '@app-selflearnv2module/feature/self-learn-v2/components/yt-videos/yt-videos.component';
import { TermsComponent } from '@app-shared/components/auth/terms/terms.component';
// import { SmartChoiceComponent } from '@app-selflearnv2module/feature/self-learn-v2/components/smart-choice/smart-choice.component';
// import { CyopComponent } from '@app-selflearnv2module/feature/self-learn-v2/components/cyop/cyop.component';


const appRoutes: Routes = [
  {
    path: '',

    component: DefaultLayoutComponent,
    children: [
      {
        path: '',
        component:
          environment?.portal == 'teacher'
            ? TeacherHomeComponent
            : TermsComponent,
        pathMatch: 'full',
      },
      {
        path: 'home',
        component:
          environment?.portal == 'teacher'
            ? TeacherHomeComponent
            : HomeComponent,
      },
      {
        path: 'assesments',
        component: AssesmentComponent,
      },
      // {
      //   path: 'neet',
      //   component: NeetComponent,
      // },
      // {
      //   path: 'jee',
      //   component: JeeComponent,
      // },
      // {
      //   path: 'about',
      //   component: AboutComponent,
      // },
      // {
      //   path: 'testseries',
      //   component: TestSeriesComponent,
      // },
      // {
      //   path: 'neet-liveclasses',
      //   component: NeetLandingComponent,
      // },
      // {
      //   path: 'jee-liveclasses',
      //   component: JeeLiveclassComponent,
      // },
      // {
      //   path: 'spl-testseries',
      //   component: SpecialSeriesComponent,
      // },
      // {
      //   path: 'setup-account',
      //   component: BackgroundHomepageComponent,
      //   canActivate: [AuthGuard],
      // },
      {
        path: 'ilite',
        component: IliteComponent,
      },
      {
        path: 'repeater',
        component: RepeaterComponent,
      },
      {
        path: 'dashboard',
        // tslint:disable-next-line:max-line-length
        loadChildren: () =>
          import('@app-modules/feature/dashboard/dashboard.module').then(
            (m) => m.DashboardModule
          ),
        canActivate: [AuthGuard, ProfileGuard],
      },
      {
        path: 'cyot',
        // tslint:disable-next-line:max-line-length
        loadChildren: () =>
          import('@app-modules/feature/dashboard/dashboard.module').then(
            (m) => m.DashboardModule
          ),
        canActivate: [AuthGuard, ProfileGuard],
      },
      {
        path: 'editProfile',
        // tslint:disable-next-line:max-line-length
        loadChildren: () =>
          import('@app-modules/feature/editprofile/editprofile.module').then(
            (m) => m.EditProfileModule
          ),
        canActivate: [AuthGuard, ProfileGuard],
      },
      {
        path: 'myprofile',
        // tslint:disable-next-line:max-line-length
        loadChildren: () =>
          import('@app-modules/feature/myprofile/myprofile.module').then(
            (m) => m.MyProfileModule
          ),
        canActivate: [AuthGuard, ProfileGuard],
      },
      {
        path: 'live-classes',
        loadChildren: () =>
          import('@app-modules/feature/live-classes/live-classes.module').then(
            (m) => m.LiveClassesModule
          ),
        canActivate: [AuthGuard, ProfileGuard],
      },
      {
        path: 'complete-profile',
        component: CompleteProfileComponent,
        canActivate: [AuthGuard, ProfileGuard],
      },
      {
        path: 'coming-soon',
        component: ComingsoonComponent,
      },
      {
        path: 'thankyou',
        component: ThankYouComponent,
      },
      {
        path: 'congratulations',
        component: CongrajulationsComponent,
      },
      {
        path: 'paynow',
        component: PaynowregistrationComponent,
      },
      {
        path: 'signin',
        component: SignInComponent,
      },
      {
        path: 'signup',
        component: SignInComponent,
      },
      {
        path: 'enrollnow',
        component: EnrollnowComponent,
      },
      {
        path: 'learning-festival',
        component: FestivalOfferComponent,
      },
      {
        path: 'diagnostic-test',
        component: DiagnosticTestComponent,
      },
      {
        path: 'diagnostic-test/thankyou',
        component: DiagnosticThankyouComponent,
      },
      {
        path: 'cuet-payment',
        component: CuetPaymentComponent,
      },
      {
        path: 'aits-payment',
        component: CuetPaymentComponent,
      },
      {
        path: 'auto-payment',
        component: CuetPaymentComponent,
      },
      {
        path: 'score-payment',
        component: ScoreNewPaymentComponent,
      },
      {
        path: 'score/thankyou',
        component: ScoreNewThankyouComponent,
      },
      {
        path: 'verify-otp',
        component: VerifyOtpComponent,
        data: { passwordReset: false },
      },
      {
        path: 'reset-password',
        component: CreatePasswordComponent,
      },
      {
        path: 'target-exam',
        component: TargetExamComponent,
      },
      {
        path: 'score-reschedule',
        component: ScoreActionsComponent,
        data: {
          action: 'reschedule'
        }
      }, {
        path: 'score-attempt',
        component: ScoreActionsComponent,
        data: {
          action: 'attempt'
        }
      }, {
        path: 'download-hallticket', 
        component: ScoreActionsComponent,
        data: {
          action: 'download'
        }
      }, {
        path: 'download-participation',
        component:ScoreActionsComponent,
        data:{
          action: 'participation'
        }
      },
      {
        path: 'courses',
        loadChildren: () =>
          import('@app-modules/feature/courses/courses.module').then(
            (m) => m.CoursesModule
          ),
      },
      {
        path: 'score/test-report/registration',
        component: ScoreTestReportComponent,
      },
      // {
      //   path: 'my-referrals',
      //   component: MyReferralsComponent,
      // },
      {
        path: 'selfLearn-V2',
        // tslint:disable-next-line:max-line-length
        loadChildren: () =>
          import('@app-selflearnv2module/feature/self-learn-v2/self-learn-v2-routing.module').then(
            (m) => m.SelfLearnV2RoutingModule
          ),
        canActivate: [AuthGuard, ProfileGuard],
      },
      {
        path: 'selfLearn-V2/subject',
        component: SelfLearnSubjectComponent,
      },
      // {
      //   path: 'selfLearn-V2/scg-analyze',
      //   component: SmartChoiceComponent,
      // },
      // {
      //   path: 'selfLearn-V2/cyop',
      //   component: CyopComponent,
      // },
      {
        path: 'selfLearn-V2/ytVideos', 
        component : YtVideosComponent

      },
      // {
      //   path: 'selfLearn-V2/scg-analyze',
      //   component: SmartChoiceComponent,
      // },
      // {
      //   path: 'selfLearn-V2/cyop',
      //   component: CyopComponent,
      // },
      {
        path: 'selfLearn-V2/videoplayback',
        component: SelfLearnVideoPlaybackComponent,
      },
      {
        path: 'onboarding',
        component: OnboardingComponent
      }
    ],
  },
  {
    path: '',
    component: ClassLayoutComponent,
    data: { isLiveClass: true },
    children: [
      {
        path: 'classes',
        loadChildren: () =>
          import('@app-modules/live-class-modules/classes/classes.module').then(
            (m) => m.ClassesModule
          ),
        canActivate: [AuthGuard, ProfileGuard],
      },
      {
        path: 'course/:courseId',
        loadChildren: () =>
          import('@app-modules/live-class-modules/course/course.module').then(
            (m) => m.CourseModule
          ),
        canActivate: [AuthGuard, ProfileGuard],
      },
      {
        path: 'mycourse/:courseId',
        loadChildren: () =>
          import(
            '@app-modules/live-class-modules/my-course/my-course.module'
          ).then((m) => m.MyCourseModule),
        canActivate: [AuthGuard, ProfileGuard],
      },
      {
        path: 'my-report',
        loadChildren: () =>
          import('@app-modules/live-class-modules/report/report.module').then(
            (m) => m.ReportModule
          ),
      },
    ],
  },
  {
    path: 'live-class/:eclassId',
    component: LiveClassLayoutComponent,
    canActivate: [AuthGuard],
    data: { isLiveClass: true },
    children: [
      {
        path: '',
        loadChildren: () =>
          import(
            '@app-modules/live-class-modules/live-class/live-class.module'
          ).then((m) => m.LiveClassModule),
        canActivate: [ProfileGuard],
      },
    ],
  },
  {
    path: 'live-class-recording/:eclassId',
    component: LiveClassLayoutComponent,
    data: { isLiveClass: true, isRecordingClass: true },
    children: [
      {
        path: '',
        loadChildren: () =>
          import(
            '@app-modules/live-class-modules/live-class/live-class.module'
          ).then((m) => m.LiveClassModule),
      },
    ],
  },
  
  {
    path: 'subscription',
    loadChildren: () =>
      import('@app-modules/feature/subscription/subscription.module').then(
        (m) => m.SubscriptionModule
      ),
    canActivate: [SubscriptionGuard, AuthGuard, ProfileGuard],
  },
  {
    path: 'enroll-subscription',
    loadChildren: () =>
      import('@app-modules/feature/enrollsubscription/enrollsubscription.module').then(
        (m) => m.EnrollsubscriptionModule
      ),
    canActivate: [SubscriptionGuard, AuthGuard, ProfileGuard],
  },
  {
    path: '**',
    redirectTo: '',
  },
  
];
@NgModule({
  imports: [RouterModule.forChild(appRoutes)],
  exports: [RouterModule],
})
export class CoreRoutingModule {}
